import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Order } from '../../types/order.type';

const useStyles = makeStyles({
  root: {
    height: '100%',
  },
  paperRoot: {
    padding: '1rem',
    height: 'calc(100% - 2rem)',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',

    '& p': {
      margin: 0,

      '& > span': {
        fontWeight: 'bold',
        color: '#424242',
      },
    },
  },
});

interface Props {
  order: Order;
}

export default function OrderInvoicingCard({ order }: Props) {
  const classes = useStyles();

  const { deliveryInfos } = order;

  return (
    <section className={classes.root}>
      <h4>Facturation</h4>
      <Paper className={classes.paperRoot}>
        <p>
          <span style={{ display: 'block' }}>Adresse:</span>
          {deliveryInfos.deliveryBillingAddress?.title && <p>{deliveryInfos.deliveryBillingAddress.title}</p>}
          <p>{`${deliveryInfos.deliveryBillingAddress.address} (${deliveryInfos.deliveryBillingAddress.zipCode} - ${deliveryInfos.deliveryBillingAddress.city})`}</p>
          {deliveryInfos.deliveryBillingAddress?.complement && (
            <p>{`Complément: ${deliveryInfos.deliveryBillingAddress.complement}`}</p>
          )}
          {deliveryInfos.deliveryBillingAddress?.comment && (
            <p>{`Commentaire: ${deliveryInfos.deliveryBillingAddress.complement}`}</p>
          )}
        </p>
      </Paper>
    </section>
  );
}
